import { Button, Grid, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ThemeContext } from '../../../context/ThemeContext'
import { LoginApi } from '../../../api/request/auth'
import toast from 'react-hot-toast'
import { setCookies } from '../../../services/Cookies'
import { useDispatch } from 'react-redux'
import { setDecimalPlaces, setLoggedIn, setUserDetails } from '../../../store/Slices/userSlice'
import { Navigate } from 'react-router-dom'
import { addJournalLog } from '../../../components/tab/tabview/journal/addJournalLog'

export default function UserDetail() {
    const { t } = useTranslation()
    const { darkMode } = useContext(ThemeContext)
    const dispatch = useDispatch()
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        // Get data from sessionStorage
        const data = sessionStorage.getItem("demoAccountData");
        console.log(data);

        if (data) {
            setUserData(JSON.parse(data)); // Parse the string back to an object
        }
    }, []);
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const params = { login_type: "api", username: userData?.userName, password: userData?.password };
            const { data } = await LoginApi(params);

            if (data?.token) {
                toast.success("Login successful!");
                setCookies("username", params?.username, { path: "/", secure: true, sameSite: "strict", });
                setCookies("token", data?.token, { path: "/", secure: true, sameSite: "strict", });
                setCookies("refreshToken", data?.refreshToken, { path: "/", secure: true, sameSite: "strict", });
                setCookies("clientId", data?.client?.id, { path: "/", secure: true, sameSite: "strict", });
                setCookies("gmtOffset", data?.gmtOffset, { path: "/", secure: true, sameSite: "strict", });
                localStorage.setItem("username", params?.username)
                sessionStorage.removeItem("demoAccountData");
                // addJournalLog('login', `Account ${username}: ${accountId} is logged in successfully.`);

                dispatch(setLoggedIn(true));
                dispatch(setUserDetails(data?.client));
                dispatch(setDecimalPlaces(data?.decimalPlacesForAmountFormatting));
                // Navigate("/dashboard");
            } else {
                toast.error("Login failed. Please check your credentials.");
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "An error occurred while logging in.";
            toast.error(errorMessage);
        }
    };
    return (
        <>

            <Grid container spacing={1.5} alignItems="center" >
                <Grid item xs={12}><Typography variant="h5" fontWeight={700} sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('newAccountOpen')}</Typography></Grid>
                <Grid item xs={4}><Typography textAlign='left' variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('Name')} </Typography></Grid>
                <Grid item xs={8}><Typography textAlign='left' variant="body2" color='textSecondary' >{userData?.firstName}</Typography></Grid>

                <Grid item xs={4}><Typography textAlign='left' variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('username')}</Typography></Grid>
                <Grid item xs={8}><Grid item xs={8}><Typography textAlign='left' variant="body2" color='textSecondary'>{userData?.userName}</Typography></Grid></Grid>
                <Grid item xs={4}> <Typography variant="body2" textAlign='left' sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('login')} </Typography></Grid>
                <Grid item xs={8}><Typography variant="body2" textAlign='left' color='textSecondary'>{userData?.clientID}</Typography></Grid>
                <Grid item xs={4}><Typography variant="body2" textAlign='left' sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('password')} </Typography> </Grid>
                <Grid item xs={8}><Grid item xs={8}><Typography textAlign='left' variant="body2" color='textSecondary'>{userData?.password}</Typography></Grid></Grid>

                <Grid item xs={4}><Typography variant="body2" textAlign='left' sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t("investorPassword")}</Typography></Grid>
                <Grid item xs={8}><Typography variant="body2" textAlign='left' color='textSecondary'>{userData?.investorPassword}</Typography></Grid>

                <Grid item xs={4}><Typography variant="body2" textAlign='left' sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t("server")}</Typography> </Grid>
                <Grid item xs={8}><Typography variant="body2" textAlign='left' color='textSecondary'>{process.env.REACT_APP_COMPANY_NAME}</Typography></Grid>

                <Grid item xs={12}><Button onClick={handleSubmit} type="submit" variant="contained" color="secondary" size="" sx={{ border: '1px solid green', marginTop: "20px", color: "white", padding: '5px', pl: 2, pr: 2, textTransform: "none", }}>{t('getStarted')} </Button></Grid>
            </Grid>

        </>
    )
}
